const ITEMS = [
  "Peace of mind today, in a world of tomorrow",
  "The Infrastructure for Audio Trust",
  "Hardware-rooted · No frills · No external drivers · No cloud dependency",
  "Patent Pending · Trademark Pending",
];

export const Marquee = () => (
  <div
    className="marquee border-y border-white/5 py-5"
    data-testid="editorial-marquee"
    aria-hidden="true"
  >
    <div className="marquee-track">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex shrink-0 items-center">
          {ITEMS.concat(ITEMS).map((text, i) => (
            <span key={i} className="flex items-center whitespace-nowrap">
              <span className="px-10 font-serif italic text-sm sm:text-base tracking-wide text-[#6B7280]">
                {text}
              </span>
              <span className="h-1 w-1 bg-[#C4A24C]" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
